import cn from "classnames"
import "keen-slider/keen-slider.min.css"
import { useKeenSlider } from "keen-slider/react"
import { useState } from "react"
import * as styles from "./SupplierTestimonials.module.scss"

const SupplierTestimonials = ({ elements }) => {
  const [currentSlide, setCurrentSlide] = useState(0)
  const [loaded, setLoaded] = useState(false)

  const [sliderRef, instanceRef] = useKeenSlider(
    {
      slides: {
        perView: 1.5,
        spacing: 20,
      },
      breakpoints: {
        "(min-width: 480px)": {
          slides: {
            perView: 2,
            spacing: 30,
          },
        },
      },
      initial: 0,
      slideChanged(s) {
        setCurrentSlide(s.track.details.rel)
      },
      created() {
        setLoaded(true)
      },
    }
  )

  return (
    <div className={styles.testimonials}>
      <div className={styles.title}>
        <h3>Testimonials</h3>
        {loaded && instanceRef.current && (
          <div className={styles.arrows}>
            <button
              className={cn(styles.prev, {
                [styles.disabled]: currentSlide === 0,
              })}
              onClick={() => instanceRef.current?.prev()}
            />
            <button
              className={cn(styles.next, {
                [styles.disabled]: currentSlide === instanceRef.current?.slides.length - instanceRef.current?.options.slides.perView,
              })}
              onClick={() => instanceRef.current?.next()}
            />
          </div>
        )}
      </div>
      <div className={cn(styles.slider, "keen-slider")} ref={sliderRef}>
        {elements.length
          ? elements.map((item, i) => {
              const hasQuotes = item.testimonialtext.charAt(0) === '"'
              const quote = hasQuotes ? item.testimonialtext : `"${item.testimonialtext}"`
              return (
                <div key={`testimonial ${i}`} className={cn(styles.testimonial, "keen-slider__slide")}>
                  <p>{quote}</p>
                  <span>{item.testimonialname}</span>
                </div>
              )
            })
          : null}
      </div>
    </div>
  )
}



export default SupplierTestimonials
